import * as React from 'react';
import { observer } from 'mobx-react';
import { FormFields } from '../../core/forms';
import {
    closeOverlay,
    openOverlay,
    OverlayComponentProps,
    OverlayNote,
    OverlayNoteButton,
    OverlayNotePosition
} from '../overlay';
import { injectTSDI } from '../../core/tsdi';
import { I18nStore } from '../../core/i18n-store';
import { getInvalidFields } from './util';

const VALIDATION_POPUP_ID = 'validation-popup';

export const openValidationPopup = (
    formFields: FormFields<unknown>,
    position: OverlayNotePosition,
    labelKey?: string
) => {
    openOverlay({
        id: VALIDATION_POPUP_ID,
        component: (props) => (
            <ValidationPopup
                {...props}
                formFields={formFields}
                position={position}
                labelKey={labelKey}
            />
        )
    });
};

export const closeValidationPopup = () => {
    closeOverlay(VALIDATION_POPUP_ID);
};

interface ValidationPopupProps extends OverlayComponentProps {
    formFields: FormFields<unknown>;
    position: OverlayNotePosition;
    labelKey?: string;
}

const ValidationPopup = observer((props: ValidationPopupProps) => {
    const { translate } = injectTSDI(I18nStore);
    const { labelKey, formFields, position, closeOverlay } = props;
    const invalidFields = getInvalidFields(formFields);

    React.useEffect(() => {
        if (invalidFields.length === 0) {
            closeOverlay();
        }
    }, [invalidFields.length]);

    return (
        <OverlayNote position={position}>
            <b>{translate('onlinepages.data.incomplete')}</b>
            <div>
                {translate('onlinepages.data.incomplete.description')}
                <ul>
                    <li>
                        <i>{labelKey && translate(labelKey)}</i>
                    </li>
                    {invalidFields.map((field) => (
                        <li key={field.label}>
                            {field.label}{' '}
                            <span className="overlay__extra-text">
                                {translate(field.error)}
                            </span>
                        </li>
                    ))}
                </ul>
            </div>
            <OverlayNoteButton onClick={closeOverlay}>
                {translate('onlinepages.ok.all.clear')}
            </OverlayNoteButton>
        </OverlayNote>
    );
});
